.table-head-cell {
  border-bottom: 0.1rem solid var(--color-grayscale-tuna);

  &:first-child,
  &:last-child {
    padding-inline-start: 1.6rem;
  }
}

.executive-label {
  cursor: default;
  background: transparent;
  color: var(--color-grayscale-ghost);
  font-size: 1.4rem;
  font-weight: 400;
}

.table-row {
  input,
  div {
    color: var(--color-grayscale-white);
  }

  &[data-hidden='true'] {
    .cell {
      *:not(button),
      *:hover:not(button),
      *:focus-visible:not(button) {
        color: var(--color-grayscale-trout);
      }
    }
  }
}
